import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../css/LoginPage.css';
import Footer from './Footer';
import PublicNavbar from './PublicNavbar';
import { apiFetch } from '../api';

import usePageTitle from '../hooks/usePageTitle';
const demoCredentials = {
  email: 'demo@neurotraining',
  password: 'demo123'
};

export default function LoginPage() {
  usePageTitle('Accedi');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchParams.get('demo') === '1') {
      setEmail(demoCredentials.email);
      setPassword(demoCredentials.password);
    }
  }, [searchParams]);

  const performLogin = async (nextEmail, nextPassword) => {
    const response = await apiFetch('/api/login', {
      auth: false,
      method: 'POST',
      body: { email: nextEmail, password: nextPassword }
    });

    const data = await response.json();

    if (data.token && data.user) {
      localStorage.setItem('authToken', data.token);
      localStorage.setItem('trainerId', data.user._id);
      localStorage.setItem('nickname', data.user.nickname || '');
      localStorage.setItem('username', data.user.username || nextEmail.split('@')[0]);
      localStorage.setItem('role', data.user.role || 'trainer');
      localStorage.setItem('user', JSON.stringify(data.user));

      if (data.user.role === 'company') {
        navigate('/company/dashboard');
      } else if (data.user.role === 'admin') {
        navigate('/admin/trainers');
      } else {
        navigate('/dashboard');
      }
      return;
    }

    throw new Error(data.message || 'Errore durante il login');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await performLogin(email, password);
    } catch (err) {
      console.error('Errore login:', err);
      setError(err.message || 'Errore di connessione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <PublicNavbar />

      <div className="login-wrapper">
        <div className="login-card">
          <h2>Accedi</h2>

          {searchParams.get('expired') === '1' && !error && (
            <div className="alert alert-warning">Sessione scaduta: effettua di nuovo l'accesso.</div>
          )}
          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                className="form-control"
                placeholder="Inserisci la tua email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                className="form-control"
                placeholder="Inserisci la password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? 'Caricamento...' : 'Accedi'}
            </button>
          </form>

          <p className="text-center mt-3">
            Non hai un account? <a href="/register">Registrati</a>
          </p>

          <p className="text-center mt-3">
            Password dimenticata? <a href="/forgot-password">Recupera password</a>
          </p>

        </div>
      </div>

      <Footer />
    </div>
  );
}
